<template>
  <div>
    <div class="help_Info_right fr">
      <div class="help_Info_right_top fl">购物流程</div>
      <div class="help_Info_right_bootm shoppstep fl">
        <span class="help-title">西始购物流程：</span>
        <span class="help-title-more">登录账户-查找商品-加入购物车-提交订单--确认收货-对公转账</span>
        <dl>
          <dt>一、登录账户</dt>
          <dd>1、输入账号、密码进行登录。</dd>
        </dl>
        <dl>
          <dt>二、查找商品</dt>
          <dd>西始为您提供多种搜索方式，例如：</dd>
          <dd>1、精确搜索：把您想要购买的商品名称或关键词输入在上方的搜索框中。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/8.jpg"></dd> -->
          <dd>2、分类筛选：例如您想要购买丙纶安全绳，即可点击首页“全部分类”中的“劳保安防”品类，搜索到“丙纶安全绳”，即可点击订购。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/9.jpg"></dd> -->
          <!-- <dd><img src="/static/image/help/shopstep/10.jpg"></dd> -->
          <dd>3、品牌筛选：；例如您想购买ABB品牌商品，即可点击首页左边栏"ABB"品牌，进入品牌检索页订购您需要的商品。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/11.jpg"></dd> -->
          <dd>4、在搜索商品的过程中，如果您遇到了任何问题，皆可拨打客服热线：400-665-8016，咨询客服。</dd>
        </dl>
        <dl>
          <dt>三、加入购物车</dt>
          <dd>1、加入购物车：找到所需商品后，选择商品规格、数量后，点击“加入购物车”。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/14.jpg"></dd> -->
          <dd>2、查看购物车：找齐所需商品后，可以查看购物车，确认商品和数量，准备下单。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/15.jpg"></dd> -->
          <!-- <dd><img src="/static/image/help/shopstep/16.jpg"></dd> -->
        </dl>
        <dl>
          <dt>四、提交订单</dt>
          <dd>1、确认好购物车的商品信息后。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/17.jpg"></dd> -->
          <dd>2、联系客服确认发票信息：</dd>
          <dd>①普通发票中，如果发票抬头为个人，仅需填写发票抬头；如果发票抬头为企业，还需填写纳税人识别号。</dd>
          <dd>②工厂/企业可开具增值税专用发票，需填写发票抬头、纳税人识别号、注册地址、注册电话、开户银行、银行账户信息。</dd>
          <dd>③无论开具哪种发票，都需填写收票人地址。填写完成后，点击保存。</dd>
          <dd>④请于3个月之内联系客服开具发票，逾期不再补开发票。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/18.jpg"></dd> -->
          <!-- <dd><img src="/static/image/help/shopstep/19.jpg"></dd> -->
          <!-- <dd><img src="/static/image/help/shopstep/20.jpg"></dd> -->
          <dd>3、提交订单。订单信息都确认无误后，即可点击“提交订单”。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/21.jpg"></dd> -->
          <dd>订单提交后，您可以通过点击“用户中心”，或者右侧订单状态文字（待付款、待发货、待收货），即可进入订单中心，查看订单状态，或进行支付、取消订单、确认收货等操作。如果提交订单有误，可取消订单，重新下单。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/22.jpg"></dd> -->
          <!-- <dd><img src="/static/image/help/shopstep/23.jpg"></dd> -->
        </dl>
        <dl>
          <dt>五、确认收货</dt>
          <dd>收到商品，请验货后签收，签收即代表收货人对商品无异议。</dd>
        </dl>
        <dl>
          <dt>六、对公转账</dt>
          <dd>验货签收后您可使用转账、汇款的方式，将货款支付到我司对公账户。</dd>
          <!-- <dd><img src="/static/image/help/shopstep/28.jpg"></dd> -->
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shopstep"
};
</script>

<style>
</style>